import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { NodeCourseEdit } from './node-course-edit'
import { NodeCourseDelete } from './node-course-delete'
import { Grid, GridItem3 } from '../../../../../../shared/chart/grid'
import { CourseAssessment } from '../graphs/course-assessment'
import { AnalyticGeneralCourse } from '../graphs/analytic-general-course'
import { AnalyticCustomCourse } from '../graphs/analytic-custom-course'
import { IconCourse } from '../../../../../../shared/icon/icon'
import { NodeCourseMove } from './node-course-move'
import { NodeCourseCopy } from './node-course-copy'
import { AssessmentRoute } from '../../../../../../view/common/assessment/route'
import { NodeCourseEditSys } from './node-course-edit-sys'
import { LoginSysAdmin } from '../../../../../../role/components/login-sys-admin'
import { NodeCourseTemplate } from './node-course-template'
import { CourseMenu } from '../../common/menu/node-actions'
import { PermissionNode } from '../../common/permission/permission-node'
import { useRoleOrgAnalytic, useRoleOrgAssessmentManage } from '../../../../../../role/hook/role-org'
import { RoleOrgAnalytic, RoleOrgAssessmentReport } from '../../../../../../role/components/role-org'
import { AiDashboard } from '../../common/ai/ai-dashboard'
import { FeatureAI } from '../../../../../../shared/component/org-feature'
import { AnalyticRoutes } from '../../../../../../view/analytics/course/analytic-routes'
import { AnalyticLegacyLayout } from '../../../../../../view/analytics/course/analytic-legacy/layout'
import { NodeSaveItemList } from './node-save-item-list'
import { SaveSystem } from '../graphs/save-system'
import { NodeSaveSnapshotList } from './node-save-snapshot-list'
import { useDataContext } from '../data-context'

export const NodeCourseDetails = ({ parentURL }) => {
  const { url } = useRouteMatch()
  const { nodeID } = useParamsInt()

  const dataContext = useDataContext()

  let course = useMemo(() => dataContext.courses.find(i => i.id === nodeID), [dataContext.courses, nodeID])

  const roleOrgAssessmentManage = useRoleOrgAssessmentManage()
  const roleOrgAnalytic = useRoleOrgAnalytic()

  const title = useMemo(() => (course ? course.name : ''), [course])

  const HeaderMenu = () => <CourseMenu place="header" url={url} node={course} nodeID={nodeID} />

  return (
    <React.Fragment>
      <BreadcrumbView text={title} Icon={IconCourse}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <Grid>
            <RoleOrgAssessmentReport accessRead>
              <GridItem3>
                <CourseAssessment nodeID={nodeID} showConfigButton={roleOrgAssessmentManage.accessRead} />
              </GridItem3>
            </RoleOrgAssessmentReport>
            <RoleOrgAnalytic accessRead>
              <GridItem3>
                <AnalyticGeneralCourse nodeID={nodeID} showConfigButton={roleOrgAnalytic.accessUpdate} />
              </GridItem3>
              <GridItem3>
                <AnalyticCustomCourse nodeID={nodeID} />
              </GridItem3>
            </RoleOrgAnalytic>
            {/* <FeatureHeatmap>
              <RoleOrgHeatmap accessRead>
                <GridItem3>
                  <CourseHeatmap nodeID={nodeID} />
                </GridItem3>
              </RoleOrgHeatmap>
            </FeatureHeatmap> */}

            <LoginSysAdmin>
              <GridItem3>
                <SaveSystem nodeID={nodeID} />
              </GridItem3>
            </LoginSysAdmin>
          </Grid>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <React.Fragment>
        <PermissionNode url={url} nodeID={nodeID} />

        <Route path={`${url}/move`}>
          <NodeCourseMove parentURL={url} nodeID={nodeID} />
        </Route>
      </React.Fragment>

      <Route path={`${url}/edit`}>
        <NodeCourseEdit parentURL={url} nodeID={nodeID} />
      </Route>
      <LoginSysAdmin>
        <Route path={`${url}/edit-sys`}>
          <NodeCourseEditSys parentURL={url} nodeID={nodeID} />
        </Route>
      </LoginSysAdmin>
      <FeatureAI>
        <Route path={`${url}/ai`}>
          <AiDashboard nodeID={nodeID} />
        </Route>
      </FeatureAI>
      <Route path={`${url}/delete`}>
        <NodeCourseDelete grandParentURL={parentURL} parentURL={url} nodeID={nodeID} />
      </Route>
      <Route path={`${url}/copy`}>
        <NodeCourseCopy nodeID={nodeID} parentURL={url} />
      </Route>
      <Route path={`${url}/template`}>
        <NodeCourseTemplate nodeID={nodeID} parentURL={url} />
      </Route>

      <Route path={`${url}/save-configure`}>
        <NodeSaveItemList nodeID={nodeID} />
      </Route>

      <Route path={`${url}/save-snapshot`}>
        <NodeSaveSnapshotList nodeID={nodeID} />
      </Route>

      <AnalyticRoutes />
      <AnalyticLegacyLayout />
      {/* <HeatmapLayoutNode /> */}
      <AssessmentRoute nodeID={nodeID} />
    </React.Fragment>
  )
}
